import Image from "next/image";
import React from "react";
import HLoading from '@/../public/giphy.gif'
const HotelLoading = () => {
  return (
    <>
      <div className="relative h-screen flex justify-center items-center">

          <Image
            src={HLoading}
            className="rounded-full h-72 w-56 transform   "
            alt="logo"
            width={400}
            height={400}
            layout="fixed"
          />
      
      </div>
    </>
  );
};

export default HotelLoading;
